import React from 'react'

import SurgicalOrderIntegrationLayout from 'presentation/doctor/layouts/SurgicalOrderIntegration'

export default function SurgicalOrderIntegration() {
  return <SurgicalOrderIntegrationLayout />
}
